<template>
  <v-card flat class="settings-card">
    <v-container>
      <v-card-title class="settings-header-text">Account Details</v-card-title>
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Company Name"
                v-model="companyName"
                readonly
                class="py-1"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Phone Number"
                placeholder="Add an account phone number"
                v-model="phoneNumber"
                readonly
                class="py-1"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Subscription"
                v-model="subscription"
                readonly
                class="py-1"
                dense
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Balance"
                v-model="accountBalance"
                readonly
                :error-messages="
                  settings.balance > 0
                    ? ''
                    : 'You need to add funds to your account'
                "
                class="py-1"
                dense
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="fundAmount"
                class="py-1"
                dense
                :items="fundAmounts"
                item-text="text"
                item-value="value"
                label="Add Amount"
                outlined
              >
                <template slot="append-outer">
                  <v-btn small color="primary" @click="addFunds">Add Funds</v-btn>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <!-- PUT PRODUCT PRICING HERE -->
          </v-row>
        </v-form>
      </v-container>
    </v-container>
  </v-card>
</template>

<script>
import axios from "axios";
import { API_BASE_URL, STRIPE_PUBLIC_API_KEY } from "../../globalVars";
import { CentsToDollars } from "../../helpers/moneyFormatter";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe(STRIPE_PUBLIC_API_KEY);

export default {
  name: "AccountSettings",
  components: {},
  data: function() {
    return {
      hoverCheck: {},
      productPricing: null,
      subscription: null,
      fundAmount: 2000
      // fundAmounts: [
      //   2000,
      //   4000,
      //   6000,
      //   8000,
      //   10000,
      //   15000,
      //   20000,
      //   25000,
      //   50000,
      //   75000,
      //   100000
      // ]
    };
  },
  created() {
    // this.$store.dispatch("entities/subscriptionTypes/hydrate", 0);
    this.$store.dispatch("entities/accounts/hydrate", 0);
    this.getPricing();
  },
  computed: {
    account() {
      return this.$store.getters["entities/accounts/query"]()
        .withAllRecursive(1)
        .first();
    },
    companyName() {
      return this.account ? this.account.name : "";
    },
    // plan() {
    //   return this.account && this.account.subscription
    //     ? this.account.subscription.name
    //     : "";
    // },
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    },
    accountBalance() {
      return this.settings && this.settings.balance
        ? CentsToDollars(this.settings.balance)
        : CentsToDollars(0);
    },
    phoneNumber() {
      return this.account ? this.account.formattedPhone : "";
    },
    fundAmounts() {
      const items = [
        2000,
        4000,
        6000,
        8000,
        10000,
        15000,
        20000,
        25000,
        50000,
        75000,
        100000
      ];
      return items.map(val => {
        return { value: val, text: CentsToDollars(val) };
      });
    }
  },
  methods: {
    saveButton(evt) {
      evt.preventDefault();
      let vueThis = this;
      this.$store.dispatch(
        "entities/bizReviewSettings/updateBizReviewsSettings",
        vueThis.reviewSettings
      );
    },
    async getPricing() {
      const accountId = this.account.id;
      let pricingResults = await axios({
        method: "get",
        url: API_BASE_URL + `/billing/products?accountId=${accountId}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      });
      this.productPricing = pricingResults.data.data;
      this.subscription = pricingResults.data.data
        .filter(val => {
          return ["M", "Y"].includes(val.frequency);
        })
        .map(val => val.productName);
    },
    async addFunds() {
      const accountId = this.account.id;
      const fundAmount = this.fundAmount;
      let response;
      try {
        response = await fetch(
        `${API_BASE_URL}/billing/add-funds?accountId=${accountId}&amount=${fundAmount}`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          }
        );
        const session = await response.json();
        const stripe = await stripePromise;
        const result = await stripe.redirectToCheckout({
          sessionId: session.id
        });
      } catch (error) {
        // If `redirectToCheckout` fails due to a browser or network
        // error, display the localized error message to your customer
        // using `result.error.message`.
        alert(
          "There was an issue contacting our payment provide. Please try again later."
        );
      }
    }
  }
};
</script>

<style scoped lang="stylus"></style>
